import axios from "axios";
import { isNil, omitBy } from 'lodash-es';
import { NotFoundError, ValidationError } from "../../library/classes/exceptions";
import { defaultHeaders } from "./default-headers";

const DEBUG = process.env.NODE_ENV === 'development';

const redirectToLogin = async () => {
  localStorage.removeItem('ACCESS_TOKEN');
  localStorage.removeItem('REFRESH_TOKEN');
  localStorage.removeItem('USER');

  window.location.href = '/login';
}

const redirectTo404 = async () => {
  // window.history.pushState("", "", "/404");
  throw new NotFoundError('Resource not found')
}


export const axiosInstance = axios.create({
  withCredentials: true,
  baseURL: `${process.env.REACT_APP_BASE_API_URL}/${process.env.REACT_APP_VERSION_V1}/`,
});

// Intercepting requests
axiosInstance.interceptors.request.use(
  (request) => {
    const headers = {
      ...defaultHeaders(),
      ...request?.headers
    };
    /* eslint-disable no-console */
    if (DEBUG)
      console.info(`%c ${request.method?.toUpperCase()} ===> ${request.url}`, 'background: #62687a; color: #fff');
    /* eslint-enable no-console */

    return { ...request, headers };
  },
  (error) => Promise.reject(error)
);


// Intercepting responses
axiosInstance.interceptors.response.use(
  (response) => {
    // do something here
    if (!response.data.status) {
      console.log({ response })
      if (response.data?.type === 'ValidationError') {
        return Promise.reject(new ValidationError(response.data?.message, response.data?.errors, true))
      }
      return Promise.reject(response.data)
    }
    // return new Promise(resolve => setTimeout(() => {
    //   resolve(response.data);
    // }, 2000))
    return response.data
  },
  async (error) => {
    console.log(error)

    let statusCode = error.response?.status || 500;
    if (error.code == 'ERR_NETWORK') {
      statusCode = 503
    }

    if (DEBUG) console.error(statusCode, error.message);


    switch (statusCode) {
      case 401:
        return redirectToLogin();
      case 430: {
        // do something else, redirecting to login for the time being
        return redirectToLogin();
      }
      case 404: {
        //Throw error directly in case of non get 404
        if (error.config.method !== 'get') {
          return Promise.reject(new Error('Invalid Action'))
        }
        return redirectTo404();
      }
      case 503:
        return Promise.reject(new Error('Unable to reach Leoprinting Servers', error));
      default:
        return Promise.reject(error);
    }
  }
)

export const axiosCancellable = (action) => {
  const controller = new AbortController();
  const cancelIntercept = axiosInstance.interceptors.request.use((config) => {
    config.signal = controller.signal
    return config
  },
    (error) => Promise.reject(error)
  )
  action().then(() => {
    axiosInstance.interceptors.request.eject(cancelIntercept)
  })
  return controller
}

export const removeNill = (obj) => {
  return omitBy(obj, isNil);
}